import * as React from 'react';
import './logo.module.scss';
import { Logo } from '../../../commonv2/components/navigation/LikesLogo';
import { LogoSvg } from './LogoSvg';

// eslint-disable-next-line no-unused-vars
export const LikesLogo = ({ className = undefined, styleName = undefined }) => <LogoSvg className={className} />;

// eslint-disable-next-line no-unused-vars
export const HeaderLogo = ({ className = undefined, styleName = undefined, onClick = undefined }) => (
    <Logo styleName="header-logo" className={className} onClick={onClick} />
);
